module.exports = function() {
  return new Worker(__webpack_public_path__ + "c35056008b2d98016ae1.worker.js");
};